import { RouteRef, SubRouteRef } from '@backstage/core-plugin-api';

import { PageId } from '@spotify/plugin-confidence-tracking-react';

export type PageRouteRef = RouteRef | SubRouteRef;

export type PageDescriptor = {
  id: PageId;
  routeRef: PageRouteRef;
  parent?: PageRouteRef;
  title: string;
  defaultTab?: string;
};

const registry = new WeakMap<PageRouteRef, PageDescriptor>();

export const registerPage = (descriptor: PageDescriptor): void => {
  registry.set(descriptor.routeRef, descriptor);
};

export function getPageDescriptor(routeRef: PageRouteRef): PageDescriptor;

export function getPageDescriptor(
  routeRef: PageRouteRef,
  options: { required: false },
): PageDescriptor | undefined;

export function getPageDescriptor(
  routeRef: PageRouteRef,
  options?: { required: false },
): PageDescriptor | undefined {
  const descriptor = registry.get(routeRef);
  if (!descriptor && options?.required !== false) {
    throw new Error(
      'No page descriptor registered for this route ref. Use createPageRoute() to create routes that render as pages.',
    );
  }

  return descriptor;
}
